import AfChecked from '@/components/AfChecked';
import AfInput from '@/components/AfInput';
import Constants from '@/Constants';
import { AnswerOption } from '@/models/QuestionCreateData';
import { ApplicationState } from '@/store';
import { LocaleData } from '@/translations/LocaleData';
import React from 'react';
import { useSelector } from 'react-redux';
import './style.scss';

interface PropsType {
    item: AnswerOption;
    onChecking: (checked: boolean) => void;
    handleChange: (value: string) => void;
    onDelete: () => void;
}

const EditAlternative = ({ item, onChecking, handleChange, onDelete }: PropsType) => {
    const strings: LocaleData = useSelector((state: ApplicationState) => state.locale.data);

    return (
        <div className="edit-question">
            <AfChecked handleClick={(checked) => onChecking(checked)} value={item.isCorrect} />

            <AfInput placeholder={strings.ALTERNATIVE} setText={(text) => handleChange(text as string)} text={item.description} />

            <i className="material-icons close" onClick={onDelete}>
                {Constants.icons.CLOSE}
            </i>
        </div>
    );
};

export default EditAlternative;
